exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-7179bdc4]:not(.disabled){cursor:pointer}a.disabled[data-v-7179bdc4]{cursor:default;pointer-events:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-7179bdc4","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/vue-typeahead-bootstrap/src/components/VueTypeaheadBootstrapListItem.vue
// module id = 926
// module chunks = 0